export enum RecognitionActionStatus {
  Needed = 'needed',
  Taken = 'taken',
  Disregarded = 'disregarded',
}
